import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {FileDownloaderService} from '@services/file-downloader.service';
import {environment} from 'environments/environment';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class ApiUserSessionService {

    constructor(
        private httpClient: HttpClient,
        private fileDownloaderService: FileDownloaderService,
    ) {
    }

    /**
     * Get user session avatar
     */
    public getAvatar(): Observable<string> {
        return this.fileDownloaderService
            .downloadDataAsBase64(`${environment.BaseApiUrl}/UserSession/Avatar`);
    }

}
